import { expandImageTiles } from './expand-image-tiles';
import { readExpansionStatusFromStorage } from './read-expansion-status-from-storage';

export const restoreExpansionStatus = (showMoreColorsLink: HTMLElement, imageTileContainer: HTMLElement, productId: string) => {
    const wasExpandedBefore = readExpansionStatusFromStorage(productId);
    if (wasExpandedBefore) {
        expandImageTiles(showMoreColorsLink, imageTileContainer, productId);
    }
};
